module.exports = __webpack_public_path__ + "static/media/portfolio1 (19).b832baf2.jpeg";